import script from "./SurveyDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyDescription.vue?vue&type=script&setup=true&lang=js"

import "./SurveyDescription.vue?vue&type=style&index=0&id=1db332bc&lang=scss"

const __exports__ = script;

export default __exports__